import { useTranslation } from "react-i18next";
import { ActionItem } from "../../../types";
import ActionRow from "./ActionRow";

interface Props {
  items: ActionItem[];
  total: number;
}

/**
 * "Team" band: rows belonging to other people, always carrying an assignee
 * tag (ActionRow renders it whenever `assignee` is populated). The list is
 * capped server-side. Band items mix entity kinds (ORDER and
 * PURCHASE_REQUEST), and no single existing screen shows this exact mix, so
 * once `total` proves there's more than what's rendered we say so as plain
 * text rather than link somewhere that would only ever be right for half the
 * rows.
 */
const TeamAttentionList = ({ items, total }: Props) => {
  const { t } = useTranslation();

  return (
    <section className="manager-dashboard__band">
      <h2 className="manager-dashboard__band-title">
        {t("managerDashboard.team.title")}
      </h2>
      {items.length === 0 ? (
        <p className="manager-dashboard__empty">
          {t("managerDashboard.team.empty")}
        </p>
      ) : (
        <div className="manager-dashboard__list">
          {items.map((item) => (
            <ActionRow key={`${item.type}-${item.entityId}`} item={item} />
          ))}
          {total > items.length ? (
            <span className="manager-dashboard__see-all">
              {t("managerDashboard.team.overflow", {
                count: total - items.length,
              })}
            </span>
          ) : null}
        </div>
      )}
    </section>
  );
};

export default TeamAttentionList;
